import BehaviorConfig from '@/models/app-config/behavior/behavior'
import ConditionForContactLens from './contactlens/ConditionForContactLens.vue'
import Condition from './default/Condition.vue'

export function getConditionView(behavior: BehaviorConfig = BehaviorConfig.forHost) {
  if (behavior.isLikeHotellovers) {
    return ConditionForContactLens
  }

  return Condition
}
